export * from './error-403.component';
export * from './error-403.module';
